module.exports = __webpack_public_path__ + "img/tokenBox25.9ff2dbc0.png";